import { EmblaOptionsType } from 'embla-carousel';
import React from 'react';
import { CarouselBeta, CarouselSlideBeta } from '@zooplus/ui-components';
import { OwnBrandReview } from './own-brand-review/OwnBrandReview';

import styles from './OwnBrandSocialPreviews.module.scss';
import { useTranslation } from '../../hooks/use-translations';
import { range } from '../../utils';

export const OwnBrandSocialPreviews = () => {
  const { t } = useTranslation();

  const options: EmblaOptionsType = {
    align: 'center',
    breakpoints: {
      '(min-width: 0px)': {
        align: 'center',
        slidesToScroll: 1,
      },
      '(min-width: 1199px)': {
        align: 'start',
        slidesToScroll: 2,
      },
      '(min-width: 1200px)': {
        align: 'start',
        slidesToScroll: 3,
      },
    },
    slidesToScroll: 1,
  };

  return (
    <div className={styles.containerWrap}>
      <div className={styles.container}>
        <h2 className={styles.title}>{t('ob.userreviews.title')}</h2>
        <CarouselBeta
          id="reviews-carousel"
          nextButtonAriaLabel="next"
          previousButtonAriaLabel="previous"
          className={styles.carouselReviews}
          emblaOptions={options}
          gap={'12px'}>
          {range(1, 3).map((reviewNum) => (
            <CarouselSlideBeta key={reviewNum}>
              <OwnBrandReview reviewNumber={reviewNum} />
            </CarouselSlideBeta>
          ))}
        </CarouselBeta>
        <div id="recommendation"></div>
      </div>
    </div>
  );
};
